import React from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

const DeleteModal = ({ isOpen, toggle, onConfirm, item }) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            size="sm"
            className="fadeInModal"
            centered
        >
            <ModalBody className="text-center">
                <h5 className="text-danger">
                    <i className="bi bi-exclamation-triangle-fill"></i> Delete Confirmation
                </h5>
                <p className="mt-2">
                    Are you sure you want to delete{" "}
                    <strong>{item?.name}</strong>?
                </p>
                <p className="text-muted">
                    This action cannot be undone.
                </p>
            </ModalBody>
            <ModalFooter className="d-flex">
                <Button
                    color="white"
                    onClick={toggle}
                    className="btn-outline-secondary px-4"
                >
                    Cancel
                </Button>
                <Button
                    color="danger"
                    onClick={() => {
                        onConfirm(item);
                        toggle();
                    }}
                    className="px-4"
                >
                    <i className="bi bi-trash-fill me-2"></i>Delete
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteModal;
